import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=8ba2acac&"
import script from "./sku.vue?vue&type=script&lang=ts&"
export * from "./sku.vue?vue&type=script&lang=ts&"
import style0 from "./sku.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports